import { Button, ButtonMode, Icon, ICONS, Loader, Tooltip } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { useEffect, useRef, useState, ReactElement } from 'react';

import styles from './ActionButton.module.scss';

const cx = classNames.bind(styles);

interface ActionButtonProps {
  icon: ICONS;
  onClick: () => void;
  isLoading?: boolean;
  tooltip: string;
  ariaLabel?: string;
  dataTestId: string;
  children?: string;
  className?: string;
  selected?: boolean;
  disabled?: boolean;
  showTooltipWhenDisabled?: boolean;
}
const ActionButton = ({
  icon,
  onClick,
  isLoading,
  tooltip,
  ariaLabel,
  dataTestId,
  children,
  className,
  selected,
  disabled = false,
  showTooltipWhenDisabled = false,
}: ActionButtonProps): ReactElement => {
  const [buttonWrapperWidth, setButtonWrapperWidth] = useState<number>(0);

  const buttonWrapperRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setButtonWrapperWidth(buttonWrapperRef.current?.offsetWidth!!);
  }, []);

  return (
    <Tooltip
      trigger={
        isLoading && !disabled ? (
          <div
            data-testid={`${dataTestId}-loader-container`}
            className={cx('loader-container')}
            style={{ width: buttonWrapperWidth }}
          >
            <Loader color="primary" text={null} dataTestId={`${dataTestId}-loader`} />
          </div>
        ) : (
          <div ref={buttonWrapperRef}>
            <Button
              className={cx('action-btn', { [`${className}`]: className }, { selected })}
              onClick={onClick}
              ariaLabel={ariaLabel || tooltip}
              dataTestId={dataTestId}
              mode={ButtonMode.TERTIARY}
              hasEqualSidesPadding
              disabled={disabled}
            >
              <Icon name={icon} />
              {children && <span>{children}</span>}
            </Button>
          </div>
        )
      }
      content={tooltip}
      disabled={isLoading || (disabled && !showTooltipWhenDisabled)}
    />
  );
};
export default ActionButton;
